<button
  class="btn"
  [class.btn--transparent]="isTransparent()"
  [class.btn--default]="isStyleDefault()"
  [class.btn--small]="isSmall()"
  [class.btn--big]="isBig()"
  [class.btn--bold]="isBold()"
  [disabled]="isDisabled() || isLoading()"
  [type]="buttonType()"
>
  <ng-content></ng-content>

  @if (isLoading()) {
    <preloader class="btn-preloader"/>
  }
</button>
